import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getTransactions as apiGetTransactions } from '~/api/projects2';
import type { Transaction } from '~/common/types';

export interface UseGetTransactionsOptions {
  projectId?: string;
}

export function useGetTransactions<T = Transaction[]>(
  { projectId }: UseGetTransactionsOptions,
  options?: Partial<UseQueryOptions<T, Error, T, (string | UseGetTransactionsOptions)[]>>,
) {
  return useQuery({
    enabled: !!projectId,
    queryKey: ['transactions', { projectId }],
    queryFn: () => apiGetTransactions<T>(projectId!),
    ...options,
  });
}
